{
  "name": "@nestjs-redisx/rate-limit",
  "version": "1.13.0",
  "description": "Rate limiting plugin for NestJS RedisX with multiple algorithms (fixed-window, sliding-window, token-bucket)",
  "author": "NestJS RedisX Team",
  "license": "MIT",
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "import": {
        "types": "./dist/index.d.mts",
        "default": "./dist/index.mjs"
      },
      "require": {
        "types": "./dist/index.d.ts",
        "default": "./dist/index.js"
      },
      "default": "./dist/index.js"
    },
    "./package.json": "./package.json"
  },
  "files": [
    "dist",
    "README.md",
    "LICENSE"
  ],
  "scripts": {
    "build": "tsup",
    "test": "SKIP_INTEGRATION=true vitest run",
    "test:watch": "SKIP_INTEGRATION=true vitest",
    "test:cov": "SKIP_INTEGRATION=true vitest run --coverage",
    "test:integration": "SKIP_INTEGRATION=false vitest run test/integration --pool=forks --poolOptions.forks.singleFork=true",
    "test:integration:watch": "SKIP_INTEGRATION=false vitest watch test/integration",
    "docker:up": "cd ../.. && docker-compose up -d redis",
    "docker:down": "cd ../.. && docker-compose down",
    "docker:logs": "cd ../.. && docker-compose logs -f redis",
    "test:docker": "npm run docker:up && sleep 3 && npm run test:integration; TEST_EXIT=$?; npm run docker:down; exit $TEST_EXIT",
    "test:all": "npm run test:cov && npm run test:integration",
    "lint": "eslint \"{src,test}/**/*.ts\"",
    "format": "prettier --write \"{src,test}/**/*.ts\"",
    "prepublishOnly": "node ../../scripts/check-changelog.mjs"
  },
  "keywords": [
    "nestjs",
    "redis",
    "rate-limit",
    "rate-limiting",
    "throttle",
    "fixed-window",
    "sliding-window",
    "token-bucket"
  ],
  "repository": {
    "type": "git",
    "url": "https://github.com/nestjs-redisx/nestjs-redisx.git",
    "directory": "packages/rate-limit"
  },
  "homepage": "https://nestjs-redisx.dev/en/reference/rate-limit/",
  "bugs": {
    "url": "https://github.com/nestjs-redisx/nestjs-redisx/issues"
  },
  "peerDependencies": {
    "@nestjs-redisx/core": "^1.0.0",
    "@nestjs/common": "^10.0.0 || ^11.0.0 || ^12.0.0",
    "@nestjs/core": "^10.0.0 || ^11.0.0 || ^12.0.0",
    "reflect-metadata": "^0.2.0",
    "rxjs": "^7.8.0"
  },
  "devDependencies": {
    "@nestjs-redisx/testing": "^1.13.0",
    "@nestjs/testing": "^9.0.0 || ^10.0.0 || ^11.0.0",
    "@types/node": "^20.0.0",
    "@types/supertest": "^6.0.0",
    "@typescript-eslint/eslint-plugin": "^6.0.0",
    "@typescript-eslint/parser": "^6.0.0",
    "@vitest/coverage-v8": "^1.6.0",
    "eslint": "^8.0.0",
    "prettier": "^3.0.0",
    "supertest": "^7.0.0",
    "tsup": "^8.0.0",
    "typescript": "^5.3.0",
    "vitest": "^1.6.0"
  },
  "publishConfig": {
    "access": "public"
  },
  "engines": {
    "node": ">=18.0.0"
  }
}
